export default __webpack_public_path__ + "static/media/defaultUser.15422c43.svg";